<div class="flex flex-column gap-2">
  <div class="basis-1/2">
    <nx-table-header
      class="text-[1rem]"
      label="coreModuleModule.eventsComponent.header.events">
      <ng-template nxTemplate="end">
        <nx-default-button
          (click)="refetchEvents()"
          [style]="'light'"
          [label]="'coreModuleModule.eventsComponent.header.refresh'"
          [icon]="'icon-refresh'">
        </nx-default-button>
      </ng-template>
    </nx-table-header>
    <p-table
      #httpLogTable
      [lazy]="true"
      (onLazyLoad)="loadData($event)"
      [value]="dataSource?.data"
      [scrollable]="true"
      [paginator]="true"
      [rows]="15"
      selectionMode="single" 
      [(selection)]=dataSource.selectedEvent 
      (onRowSelect)="setMenuItems()"
      [rowsPerPageOptions]="[15, 20, 50]"
      [totalRecords]="dataSource?.totalElements"
      [loading]="loading"
      [sortField]="sortProperty" 
      [sortOrder]="translateSortDirectionToSortOrder(sortDirection)"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="getCurrentPageReportTemplate()"
      [resizableColumns]="true">
      <ng-template pTemplate="caption">
        <div class="flex flex-row">
          <div class="basis-2/3 flex flex-row gap-2">
            <!-- no filter -->
          </div>
          <div class="basis-1/3 flex flex-row justify-end">
            <p-dropdown
              placeholder="Sortierung"
              [styleClass]="'sort'"
              appendTo="body"
              [ngModel] = "sortModel"
              [options]="sortOptions | translateLabels"
              [dataKey]="'key'"
              optionLabel="label"
              [showClear]="false"
              (onChange)="sort($event)">
            </p-dropdown>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr >
            <th style="min-width: 5rem; width: 8rem;">{{ 'coreModuleModule.eventsComponent.table.header.state' | translate }}</th>
            <th style="width: auto;">{{ 'coreModuleModule.eventsComponent.table.header.type' | translate }}</th>
            <th style="min-width:9.813rem; width: 9.813rem;">{{ 'coreModuleModule.eventsComponent.table.header.date' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-event>
        <tr class="clickable" [pSelectableRow]="event">
          <td>
            <p-tag 
              [value]="event.state"
              [severity]="calculateSeverity(event.state)">
        </p-tag>
          </td>
          <td>{{event.eventType}}</td>
          <td>{{event.eventDatetime | date:'dd.MM. HH:mm:ss'}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="emptyMessage">{{ 'coreModuleModule.eventsComponent.table.emptyMessage' | translate }}</td>
        </tr>
      </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
    </ng-template>
  </div>
  <div class="basis-1/2">
    <nx-headline-box
      label="coreModuleModule.eventsComponent.details.headline.event">
        <ng-template nxTemplate="end">
          <nx-default-button
            *ngIf="dataSource?.selectedEvent"
            [menuItems]="menuItems"
            [menuWithIcon]="false"
            class="pt-1"
            [icon]="'icon-options'">
          </nx-default-button>
      </ng-template>
    </nx-headline-box>
    <nx-default-box
    class="bg-white border-b border-gray"
    label="coreModuleModule.eventsComponent.details.id.label">
      {{dataSource?.selectedEvent?.id}}
      <ng-template nxTemplate="end">
        <nx-default-button
          [disabled]="!this.dataSource?.selectedEvent?.id"
          (click)="copyToClipboard(dataSource?.selectedEvent?.id)"
          [style]="'light'"
          [icon]="'icon-copy'"
          tooltip="coreModuleModule.eventsComponent.details.id.button.tooltip.copy">
        </nx-default-button>
      </ng-template>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      label="coreModuleModule.eventsComponent.details.type.label">
      {{dataSource?.selectedEvent?.eventType}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      label="coreModuleModule.eventsComponent.details.date.label">
      {{dataSource?.selectedEvent?.eventDatetime | date:'dd.MM.yyyy HH:mm:ss'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      label="coreModuleModule.eventsComponent.details.deliveryDateTime.label">
      {{dataSource?.selectedEvent?.deliveryDateTime | date:'dd.MM.yyyy HH:mm:ss'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      label="coreModuleModule.eventsComponent.details.lastFailedDateTime.label">
      {{dataSource?.selectedEvent?.lastFailedDateTime | date:'dd.MM.yyyy HH:mm:ss'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      label="coreModuleModule.eventsComponent.details.deliveryAttempt.label">
      {{dataSource?.selectedEvent?.deliveryAttempt}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      label="coreModuleModule.eventsComponent.details.lastResponseCode.label">
      {{dataSource?.selectedEvent?.lastResponseCode}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      label="coreModuleModule.eventsComponent.details.nextSendAttemptNotBefore.label">
      {{dataSource?.selectedEvent?.nextSendAttemptNotBefore | date:'dd.MM.yyyy HH:mm:ss'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      label="coreModuleModule.eventsComponent.details.entityId.label">
      {{dataSource?.selectedEvent?.entityId }}
    <ng-template nxTemplate="end">
      <nx-default-button
        [disabled]="!this.dataSource?.selectedEvent?.entityId"
        (click)="copyToClipboard(dataSource?.selectedEvent?.entityId)"
        [style]="'light'"
        [icon]="'icon-copy'"
        tooltip="coreModuleModule.eventsComponent.details.entityId.button.tooltip.copy">
      </nx-default-button>
    </ng-template>
  </nx-default-box>
  <nx-default-box
  class="bg-white border-b border-gray"
  label="coreModuleModule.eventsComponent.details.entityExternalId.label">
    {{dataSource?.selectedEvent?.entityExternalId}} 
  <ng-template nxTemplate="end">
    <nx-default-button
      [disabled]="!this.dataSource?.selectedEvent?.entityExternalId"
      (click)="copyToClipboard(dataSource?.selectedEvent?.entityExternalId)"
      [style]="'light'"
      [icon]="'icon-copy'"
      tooltip="coreModuleModule.eventsComponent.details.entityExternalId.button.tooltip.copy"> 
    </nx-default-button>
  </ng-template>
</nx-default-box>

  </div> 
</div>